import { render, staticRenderFns } from "./bandeja-asignacion-cobros.vue?vue&type=template&id=6edf4f5a&scoped=true"
import script from "./bandeja-asignacion-cobros.vue?vue&type=script&lang=js"
export * from "./bandeja-asignacion-cobros.vue?vue&type=script&lang=js"
import style0 from "./bandeja-asignacion-cobros.vue?vue&type=style&index=0&id=6edf4f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edf4f5a",
  null
  
)

export default component.exports